/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2022-11-14 13:35:36
 * @LastEditors: changfeng
 * @LastEditTime: 2024-06-24 17:06:07
 */
import React, { useState } from "react";
// import Footer from '@/components/Footer';
import UserAvatar from "@/components/UserAvatar";
import {
  Settings as LayoutSettings,
  PageContainer,
} from "@ant-design/pro-components";
import type { RunTimeLayoutConfig } from "@umijs/max";
import { history, FormattedMessage, setLocale } from "umi";
import { stringify } from "querystring";
import defaultSettings from "../config/defaultSettings";
import GlobalHeaderRight from "./components/RightContent";

import { fetchCurrentUser } from "./pages/services/services";
import type { RequestConfig } from "umi";
import { notification, Button, message as Message } from "antd";
import { SelectLang } from "umi";
import queryString from "query-string";
import {
  LogoutOutlined,
  DownOutlined,
  LeftCircleOutlined,
} from "@ant-design/icons";
import {
  getAccessToken,
  MoveTokenFromLocalStorage,
  getQueryVariable,
  SaveTokenToLocalStorage,
} from "@/utils/utils";
import "./global.less";
// 运行时配置

// 全局初始化数据配置，用于 Layout 用户信息和权限初始化
// 更多信息见文档：https://next.umijs.org/docs/api/runtime-config#getinitialstate
const loginPath = '/login';
const trackPath = '/track';

const userAgent = navigator.userAgent;
const MOBILE = userAgent.includes("Mobile");
interface InitialStateType {
  [propName: string]: any;
}
const logout = async () => {
  // 删除cookie和token
  localStorage.setItem("Authorization", "");
  MoveTokenFromLocalStorage();
  const { query = {}, search, pathname } = history.location;
  const { redirect, token } = query; // Note: There may be security issues, please note

  if (window.location.pathname !== "/login" && !redirect) {
    history.replace({
      pathname: "/login",
      search: stringify({
        redirect: pathname + search,
      }),
    });
  }
};
/**
 * @see  https://umijs.org/zh-CN/plugins/plugin-initial-state
 * */
export async function getInitialState(): Promise<{
  settings?: Partial<LayoutSettings>;
  currentUser?: any;
  loading?: boolean;
  fetchUserInfo?: () => Promise<any>;
}> {

  if(history.location.pathname === trackPath) {
    return undefined;
  }

  const token = getQueryVariable('token')

  if (token) {
    SaveTokenToLocalStorage(token);
  }

  const fetchUserInfo = async () => {
    try {
      const msg = await fetchCurrentUser();
      return msg.data;
    } catch (error) {
      // history.push(loginPath);
      const { search, pathname } = history.location;
      history.replace({
        pathname: loginPath,
        search: stringify({
          redirect: pathname + search,
        }),
      });
    }
    return undefined;
  };
  console.log("history.location.pathname ", history.location.pathname);
  if (history.location.pathname !== loginPath) {
    const userInfo = await fetchUserInfo();
    return {
      fetchUserInfo,
      currentUser: userInfo,
      settings: defaultSettings,
    };
  }
  return {
    fetchUserInfo,
    settings: defaultSettings,
  };
}

enum ErrorShowType {
  SILENT = 0,
  WARN_MESSAGE = 1,
  ERROR_MESSAGE = 2,
  NOTIFICATION = 3,
  REDIRECT = 9,
}

interface ResponseStructure {
  success: boolean;
  data: any;
  errorCode?: number;
  errorMessage?: string;
  showType?: ErrorShowType;
}

export const layout: RunTimeLayoutConfig = ({
  initialState,
}: {
  initialState: InitialStateType;
  setInitialState: () => void;
}) => {
  const currentUser = initialState?.currentUser;
  const fetchUserInfo = initialState?.fetchUserInfo;
  const [mobileCollapsed, setMobileCollapsed] = useState(true);

  /** 此处判断是移动端还是pc端，根据不同环境返回不同的布局文件 */

  console.log("userAgent", userAgent, userAgent.includes("Mobile"));
  if (MOBILE) {
    /** 如果是移动端
     * 则使用移动端布局
     */
    console.log("移动端");
    return {
      // menuExtraRender: ({ collapsed }) => !collapsed && <UserAvatar />,
      menu: {
        defaultOpenAll: true,
        autoClose: true,
        // type:'sub'
      },
      breakpoint: false,
      disableContentMargin: false,

      // collapsed:mobileCollapsed,
      // headerRender: () => <GlobalHeaderRight />,
      waterMarkProps: {
        content: currentUser?.name,
      },
      menuExtraRender: false,
      actionsRender: () => [],
      onMenuHeaderClick: () => {
        console.log(">>>>>>>");
      },
      onTopMixMenuHeaderClick: () => {
        console.log("1111111111111");
      },
      // collapsedButtonRender: () => {
      //   return (
      //     <span
      //       style={{ position: 'absolute', top: '30px', right: '0' }}
      //       onClick={() => setMobileCollapsed(!mobileCollapsed)}
      //     >
      //     <LeftCircleOutlined color='#aaa' />
      //   </span>)
      // },
      onPageChange: () => {
        const { location } = history;
        if (location.pathname === trackPath){
          history.push('/track');
        }
        if (
          location.pathname !== loginPath
        ) {
          if (currentUser === undefined || Object.keys(currentUser).length === 0) {
            fetchUserInfo();
          }
        }
        if (location.pathname === loginPath) {
          if (localStorage.getItem("Authorization")) {
            history.push("/");
          }
        }
      },

      menuHeaderRender: () => null,
      // 自定义 403 页面
      // unAccessible: <div>unAccessible</div>,
      // 增加一个 loading 的状态
      childrenRender: (children) => {
        return <>{children}</>;
      },
      ...initialState?.settings,
      title: "",
      layout: "top",
      logo: "https://tiktok-ad-tool-1255795714.cos.ap-shanghai.myqcloud.com/icon_head%402x.c0f0a41a.png",
    };
  } else {
    return {
      // menuExtraRender: ({ collapsed }) => !collapsed && <UserAvatar />,
      menu: {
        defaultOpenAll: true,
      },
      disableContentMargin: false,

      defaultCollapsed: false,
      // headerRender: () => <GlobalHeaderRight />,
      waterMarkProps: {
        content: currentUser?.name,
      },
      menuExtraRender: () => <p></p>,
      actionsRender: () => [],

      onPageChange: () => {
        const { location } = history;
        if (location.pathname === trackPath){
          history.push('/track');
        }
        if (
          location.pathname !== loginPath
        ) {
          if (currentUser === undefined) {
            fetchUserInfo();
          }
        }
        if (location.pathname === loginPath) {
          if (localStorage.getItem("Authorization")) {
            history.push("/");
          }
        }
      },

      menuHeaderRender: undefined,
      // 自定义 403 页面
      // unAccessible: <div>unAccessible</div>,
      // 增加一个 loading 的状态
      childrenRender: (children) => {
        return (
          <PageContainer
            // title={false}
            title={<GlobalHeaderRight />}
            header={{
              breadcrumb: {},
              style: {
                padding: "8px 16px 0 16px",
                backgroundColor: "#fff",
                position: "fixed",
                top: 0,
                width: "100%",
                left: 0,
                zIndex: 999,
                boxShadow: "0 2px 8px #f0f1f2",
              },
            }}
            style={{
              paddingBlockStart: 48,
            }}
            // extra={<GlobalHeaderRight />}
          >
            {children}
          </PageContainer>
        );
      },
      ...initialState?.settings,
      title: "",
      logo: null,
    };
  }
};

export const request: RequestConfig = {
  timeout: 300000,
  headers: { "X-Requested-With": "XMLHttpRequest" },
  paramsSerializer(params) {
    return queryString.stringify(params);
  },
  // other axios options you want
  errorConfig: {
    errorHandler(error: any, options: any) {
      if (options?.skipErrorHandler) throw error;
      const { response = {}, message } = error;
      const { status = null } = response;
      if (String(response) !== "{}" && response.status) {
        const errorText = response.statusText;
        const msg = response.data.message || message;
        // 401时回到登录页面
        if (status === 401) {
          notification.warn({
            message: "您未登录或登录信息已过期，请重新登陆!",
          });
          // 清除token
          // MoveTokenFromLocalStorage();
          // ...跳转到登录页面。
          // history.push(loginPath)
          const { search, pathname } = history.location;
          history.replace({
            pathname: loginPath,
            search: stringify({
              redirect: pathname + search,
            }),
          });
        } else {
          notification.error({
            message: `请求错误 [${status}]: ${msg}`,
            description: errorText,
          });
        }
      } else if (String(response) === "{}") {
        notification.error({
          description: message || "您的网络发生异常，无法连接服务器",
          message: message || "网络异常",
        });
      } else {
        notification.error({
          description: message || "您的网络发生异常，无法连接服务器",
          message: message || "网络异常",
        });
      }
      error.response = {
        message: error.message,
      };
      Message.destroy();
      return Promise.reject(error);
    },

    errorThrower: (res: ResponseStructure) => {
      const { success, data, errorCode, errorMessage, showType } = res;
      if (!success) {
        const error: any = new Error(errorMessage);
        error.name = "BizError";
        error.info = { errorCode, errorMessage, showType, data };
        throw error; // 抛出自制的错误
      }
    },
  },
  requestInterceptors: [
    (url, options) => {
      console.log("optionsssss", options);
      return {
        url,
        options: {
          ...options,
          headers: {
            Authorization: getAccessToken() || 'eyJhbGciOiJIUzI1NiJ9.eyJpZCI6NDYsImlhdCI6MTc0ODQ4ODcyNCwiZXhwIjoxNzQ4NTMxOTI0fQ.8uSoSNA-Vsnu-RB9m0RNWLoFj0a_Zui9JZZPezIOB0E',
          },
        },
      };
    },
  ],
  responseInterceptors: [
    (response: any) => {
      const { data = {} }: { url: string; status: number; data: any } =
        response;
      const { code, message } = data;
      /** 接口请求成功，做错误拦截 */
      if (code < 200 || code > 300) {
        notification.info({
          message: message,
          description: data.data,
        });
        return {
          data: {
            success: true,
            message: message,
            code: code,
          },
        };
      }
      return response;
    },
  ],
};
